export default __webpack_public_path__ + "static/media/vet-chat-split-promotional.2793580f.jpeg";